import Component from 'can/component/component';
import Swiper from 'swiper';
import _ from 'lodash';

import template from './shot-swiper.stache';

Component.extend({
    tag: 'leaderboard-shot-by-shot-swiper',
    template,
    viewModel: {
        define: {
            holes: {
                value: [],
            },
            index: {
                type: 'number',
            },
            shots: {
                value: [],
            },
        },
        initSwiper: function() {
            this.attr(
                'shots',
                [
                    ..._.get(
                        this.attr(`holes.${this.attr('index')}`),
                        'shots',
                        [],
                    ),
                ].reverse(),
            );

            const swiperContainer = $(
                '.s-shot-by-shot-swiper .swiper-container',
            );
            const paginationEl = $('.s-shot-by-shot-swiper .swiper-pagination');

            if (this.swiper) {
                this.destroySwiper(swiperContainer);
            }

            this.swiper = new Swiper(swiperContainer, {
                simulateTouch: true,
                speed: 1000,
                slidesPerColumn: 1,
                loop: true,
                pagination: {
                    el: paginationEl,
                    clickable: true,
                },
            });

            this.swiper.on('slideChangeTransitionEnd', () =>
                this.attr('activeHoleIndex', this.swiper.activeIndex),
            );
        },

        destroySwiper: function(swiperContainer) {
            if (this.swiper.destroy) {
                this.swiper.destroy(true, true);
            }

            swiperContainer.removeAttr('style');

            this.swiper = null;
        },
    },

    events: {
        inserted() {
            const compute = can.compute(() => ({
                holes: this.viewModel.attr('holes'),
                index: this.viewModel.attr('index'),
            }));
            compute.bind('change', () => {
                setTimeout(() => this.viewModel.initSwiper(), 100);
            });
            this.viewModel.initSwiper();
        },

        '.swiper-button-next click'() {
            this.viewModel.swiper.slideNext();
        },

        '.swiper-button-prev click'() {
            this.viewModel.swiper.slidePrev();
        },
    },
});
